import { useAuth } from "@jane/lib/src/auth/hook"

export function usePermissions() {
  const { hasRoles } = useAuth()
  return {
    canAccessClients: hasRoles(['manager', 'coordinator']),
    canManageEmployees: hasRoles(['manager', 'coordinator']),
    canAccessEmployees: hasRoles(['manager', 'coordinator', 'servicedesk']),
    canSeeSubjectIdOnPerson: hasRoles(['manager']),
    canManageSettings: hasRoles(['manager', 'social_cards']),

    // Teams
    canListTeams: hasRoles(['manager', 'coordinator', 'telephone', 'servicedesk']),
    canLimitedListAllTeams: hasRoles(['hoofdcoordinator']),
    canListAllTeams: hasRoles(['manager']),

    // Clients
    canListClients: hasRoles(['manager', 'coordinator', 'telephone']),
    canManageClientNetwork: hasRoles(['manager', 'coordinator']),
    canAccessClientTasks: hasRoles(['manager', 'coordinator']),
    canManageClientNotifications: hasRoles(['manager', 'coordinator']),
    canResetClientPassword: hasRoles(['manager', 'coordinator']),
    canSendClientInvite: hasRoles(['manager', 'coordinator']),
    canListClientContacts: hasRoles(['manager', 'coordinator', 'telephone']),

    // Employees
    canListEmployees: hasRoles(['manager', 'coordinator', 'telephone', 'servicedesk']),
    canListCoordinators: hasRoles(['manager']),
    canListManagers: hasRoles(['manager']),
    canManageEmployeePicture: hasRoles(['manager', 'coordinator']),
    canManageEmployeeRoles: hasRoles(['manager']),
    canManageEmployeeTeams: hasRoles(['manager']),
    canResetEmployeePassword: hasRoles(['manager', 'servicedesk']),
    canSendEmployeeInvite: hasRoles(['manager', 'coordinator']),
    canSeeEmployeeSyncStatus: hasRoles(['manager', 'coordinator']),
    canResetEmployee2fa: hasRoles(['manager', 'hoofdcoordinator', 'servicedesk']),
    canSeeEmployeeLearnCertificates: hasRoles(['manager', 'coordinator', 'learn']),
    canDestroyEmployee: hasRoles(['manager']),

    // Broadcasts
    canAccessBroadcasts: hasRoles(['telephone', 'coordinator', 'hoofcoordinator', 'manager', 'employee']),
    canManageBroadcasts: hasRoles(['manager', 'broadcasts']),

    // Learn
    canManageLearn: hasRoles(['learn', 'coordinator', 'hoofcoordinator', 'manager']),
    canSeeMyLearnCertificates: hasRoles(['telephone', 'coordinator', 'hoofcoordinator', 'manager', 'employee']),
    canEditLearnModules: hasRoles(['learn']),

    // TeamSpace
    canManageTeamSpaceTemplates: hasRoles(['manager', 'samenwerken-beheer']),

    // Documentation
    // // TODO: RE-enable
    canAccessDocumentation: false, //hasRoles(['manager', 'coordinator', 'hoofdcoordinator', 'samenwerken-beheer', 'samenwerken-toegang']),
    canManageTeamSpaces: hasRoles(['manager', 'samenwerken-beheer']),
    canEditTeamSpaceImage: hasRoles(['manager', 'samenwerken-beheer']),
    canDeleteTeamSpacePage: hasRoles(['manager', 'coordinator', 'hoofdcoordinator', 'samenwerken-beheer']),

    // Logs
    canAccessLogs: hasRoles(['manager']),

    // Phone
    canAccessPhone: hasRoles(['telephone', 'coordinator', 'hoofcoordinator', 'manager']),
    canAccessPhoneReception: hasRoles(['telephone']),
    canSeePhoneSidebar: hasRoles(['coordinator', 'telephone', 'hoofdcoordinator', 'manager']),

    // Flows
    canManageFlows: hasRoles(['manager', 'learn']),

    // Social Cards
    canManageSocialCards: hasRoles(['manager', 'coordinator', 'social_cards']),

    // App preferences
    canManageAppPreferences: hasRoles(['manager']),

    // Cache
    canManageCache: hasRoles(['manager']),
  }
}
